import { Component } from '@angular/core';
import { PusherService } from './services/pusher-service';
import { AppointmentDataService } from './components/appointment/service/data.service';
import { PCCService } from './services/pcc.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError } from "@angular/router";
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: []
})
export class AppComponent {
  title = 'angular-matrial-design';
  currentUser: any = {};
  constructor(private pusherService: PusherService,
    private appointmentService: AppointmentDataService,
    private router: Router,
    private _pccService: PCCService,
    private authService: AuthService
  ) {
    this.currentUser = this.authService.currentUser || {};
    this.pusherService.subscribeVersionChannels();
    const eventsName = ['NEW_RELEASE'];
    
      this.pusherService.subscribeNewReleaseChannel(eventsName);
      this.pusherService.new_release_notify.subscribe((pusherData) => {
        if (pusherData) {
          this.pusherService.newReleaseNotficationReceive.next(pusherData);
          // channel.unbind();
        }
      })
    

    this.appointmentService.testService();
    router.events.subscribe((event: Event) => {

      if (event instanceof NavigationStart) {
        // Show loading indicator
        if (event.url === '/appointment') {
          this.appointmentService.goToParent(true, true);
        }
      }

      if (event instanceof NavigationEnd) {
        // Hide loading indicator
      }

      if (event instanceof NavigationError) {
        // Hide loading indicator

        // Present error to user
        console.log(event.error);
      }
    });
    localStorage.setItem('eventStack', '0');
    if (localStorage.getItem('play') === null) {
      localStorage.setItem('play', 'false');
    }
    if (localStorage.getItem('pause') === null) {
      localStorage.setItem('pause', 'false');
    }
  }

  checkLogin() {
    if (window.location.pathname.includes('login') || (window.location.pathname.includes('register')) || (window.location.pathname.includes('user-create-password')) || (window.location.pathname.includes('code-verification')) || (window.location.pathname.includes('admin-login')) || (window.location.pathname.includes('auth')) || (window.location.pathname.includes('forgot-password')) || (window.location.pathname.includes('contact-us'))|| (window.location.pathname.includes('403'))) {
      return false;
    } else {
      return true;
    }
  }
}
